import axios from 'axios'
import { getInstance } from './auth/auth'
import axiosRetry from 'axios-retry'
import store from './store'
import { changeRegionURL } from '@/regions'
import { getGlobalBackendErrorDialog } from '@/utils/backendErrors'

let baseURL = ''
if (window.appConfig?.VUE_APP_ENV === 'production') {
    baseURL = window.appConfig?.VUE_APP_BACKEND_URL
} else {
    baseURL = localStorage.getItem('nvBaseUrl')
    if (!baseURL) {
        baseURL = window.appConfig?.VUE_APP_BACKEND_URL
    }
}

const $axios = axios.create({
    baseURL,
    timeout: 300000,
    headers: { 'Content-Type': 'application/json' }
})

axiosRetry($axios, {
    retries: 2,
    retryDelay: retryCount => {
        return retryCount * 1000
    }
})

// Request Interceptor
$axios.interceptors.request.use(
    async config => {
        if (getInstance().isAuthenticated) {
            const accessToken = await getInstance().getTokenSilently()
            config.headers.Authorization = `Bearer ${accessToken}`
        }
        config.metadata = { startTime: new Date() }
        return config
    },
    error => {
        Promise.reject(error)
    }
)

$axios.interceptors.response.use(
    function (response) {
        const metadata = response.config.metadata
        metadata.endTime = new Date()
        response.duration = metadata.endTime - metadata.startTime
        if (response.duration > response.headers['x-runtime-ms'] * 10) {
            const info = {
                endpoint: response.request.responseURL,
                method: response.config.method,
                status: response.status,
                feStart: metadata.startTime,
                feRuntime: response.duration,
                beRuntime: response.headers['x-runtime-ms']
            }
            console.warn(`${response.request.responseURL.split('/').pop()}: `, info)
        }
        return response
    },
    function (error) {
        const dialog = getGlobalBackendErrorDialog(error)
        if (dialog) {
            error.customErrorHandled = true
            store.dispatch('hideSnackBar')
            store.dispatch('showGlobalDialog', dialog)
            const code = error.response?.data?.code
            if (dialog.dialogTitle === 'Space in different region') {
                const regionCode = code.replace(/space.*_in_(.*)/, '$1')
                setTimeout(() => {
                    document.location = changeRegionURL(regionCode)
                }, 2000)
            }
        }
        return Promise.reject(error)
    }
)

export default $axios
